interface Feature {
  title: string;
  description: string;
  icon: string;
}

interface FeaturesProps {
  heading: string;
  features: Feature[];
}

const iconMap: Record<string, string> = {
  search: '🔍',
  graph: '🕸️',
  integration: '🔌',
  languages: '💻',
};

export default function Features({ heading, features }: FeaturesProps) {
  return (
    <div className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-center text-gray-900 mb-16">
          {heading}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              data-testid="feature-item"
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition"
            >
              <div className="text-4xl mb-4">{iconMap[feature.icon] || '⚡'}</div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
